import { render, staticRenderFns } from "./double.vue?vue&type=template&id=7a921eec&scoped=true"
import script from "./double.vue?vue&type=script&lang=ts"
export * from "./double.vue?vue&type=script&lang=ts"
import style0 from "./double.vue?vue&type=style&index=0&id=7a921eec&prod&scoped=true&lang=css"
import style1 from "./double.vue?vue&type=style&index=1&id=7a921eec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a921eec",
  null
  
)

export default component.exports